import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_HK_GU || "guhk-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_HK_GU || 26168,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_HK_GU || 0,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_HK_GU || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_HK_GU || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_HK_GU || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_HK_GU || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_GU || "",
  faqUrl: "https://faq-hk.gu-global.com/",
  showAboutApp: true
};

export default _countryEnv;
